// @ts-nocheck
import { userBrucePowerSelector } from "@store/Framework/Common/Hooks/Selectors/brucePowerSelector";
import { useSelector } from "react-redux";

const useIsBrucePowerUser = (): boolean => {
    return useSelector(userBrucePowerSelector);
};

export default useIsBrucePowerUser;
